import { $, $$, isMobile } from '@utils';

function init() {
  if (!$('[data-au-glossary]')) return;

  glossaryScrollToContent();
  searchBarGlossary();
}

function glossaryScrollToContent() {
  const activeClass = 'au-glossary__menu-link--active';
  const menuSection = $$('[data-au-glossary-letter]:not([disabled]):not(.au-hide)');
  const items = $$('[data-au-glossary-main] [data-au-accordion] > li');
  const headerHeight = $('.n-main-header-responsive') ? $('.n-main-header-responsive').clientHeight : 0;
  const glossaryMain = $('[data-au-glossary-main]');
  const glossaryMenuUl = $('[data-au-glossary-menu-ul]');
  const glossaryAside = $('[data-au-glossary-aside]');
  const asideHeight = isMobile.matches ? glossaryAside.clientHeight : 0;

  // for clickable event
  menuSection.forEach((v) => {
    v.onclick = () => {
      // clear results
      auGlossarySearchClear();
      // show all elements
      items.forEach((item) => {
        item.classList.remove('au-hide');
      });

      // scroll to target dropdown
      const target = $(v.dataset.auGlossaryLetterHref);
      const rect = target.getBoundingClientRect();
      const yPosition = rect.top;
      const offset = yPosition + window.scrollY;
      const scroll = offset - headerHeight - asideHeight + 2;
      window.scrollTo(0, scroll);

      // set active element
      setTimeout(() => {
        menuSection.forEach((j) => j.classList.remove(activeClass));
        v.classList.add(activeClass);
      }, 500);
    };
  });

  // for window scrolldown event
  window.onscroll = () => {
    const mainSection = getFirstElementWithLetterOnCollapsables();

    // scrollspy
    mainSection.forEach((v, i) => {
      const rect = v.getBoundingClientRect().y;

      // || rect < window.innerHeight
      if (rect < headerHeight + asideHeight) {
        menuSection.forEach((v) => v.classList.remove(activeClass));
        if (menuSection[i]) menuSection[i].classList.add(activeClass);
      }
    });

    // scroll menu to bottom to see rest of letters
    if (
      -glossaryMain.getBoundingClientRect().y + headerHeight - asideHeight >
      (glossaryMain.clientHeight - headerHeight + asideHeight) / 2
    ) {
      if (!isMobile.matches) {
        glossaryMenuUl.scrollTo(0, glossaryMenuUl.clientHeight / 1.5);
      } else {
        glossaryMenuUl.scrollLeft = glossaryMenuUl.clientWidth;
      }
    } else if (!isMobile.matches) {
      glossaryMenuUl.scrollTo(0, 0);
    } else {
      glossaryMenuUl.scrollLeft = 0;
    }
  };
}

function getFirstElementWithLetterOnCollapsables() {
  const allElements = $$('[data-au-glossary-main] [data-au-accordion] > li:not(.au-hide) [data-au-collapsable]');

  // Create a map to store the first occurrence of each base ID
  const uniqueElements = new Map();

  allElements.forEach((element) => {
    // Extract the base ID (remove the last `-number`)
    const baseId = element.id.replace(/-\d+$/, '');

    // If this base ID hasn't been added yet, store the element
    if (!uniqueElements.has(baseId)) {
      uniqueElements.set(baseId, element);
    }
  });

  // Convert the Map values to an array (if needed)
  const result = Array.from(uniqueElements.values());

  // Output the filtered elements
  return result;
}

function auGlossarySearch(value) {
  const items = $$('[data-au-glossary-main] [data-au-accordion] > li');
  const searchTerm = value.trim().toLowerCase();
  const glossaryMain = $('[data-au-glossary-main]');

  // Highlight searched text
  // reset previous strong
  glossaryMain.querySelectorAll('[data-au-glossary-strong]').forEach((el) => {
    const parent = el.parentNode;
    parent.replaceChild(document.createTextNode(el.textContent), el);
  });

  if (searchTerm.trim() !== '') {
    // Find and bold the matching text
    const regex = new RegExp(`(${searchTerm})`, 'gi');
    glossaryMain.querySelectorAll('.au-accordion__block-text, [data-au-collapsable-title-text]').forEach((block) => {
      block.innerHTML = block.innerHTML.replace(
        regex,
        '<strong class="au-glossary__strong" data-au-glossary-strong>$1</strong>',
      );
    });
  }

  // show / hide searched items
  items.forEach((item) => {
    if (!item.innerText.toLowerCase().includes(searchTerm)) {
      item.classList.add('au-hide');
    } else {
      item.classList.remove('au-hide');
    }
  });

  // show / hide no results div
  const itemsVisibles = $$('[data-au-glossary-main] [data-au-accordion] > li:not(.au-hide)').length;
  if (itemsVisibles === 0) {
    $('[data-au-glossary-no-results]').classList.remove('au-hide');
  } else {
    $('[data-au-glossary-no-results]').classList.add('au-hide');
  }
}

function auGlossarySearchClear() {
  const glossaryMain = $('[data-au-glossary-main]');
  const items = $$('[data-au-glossary-main] [data-au-accordion] > li');

  items.forEach((item) => {
    item.classList.remove('au-hide');
  });

  // remove input value
  $('[data-au-glossary-aside] [data-au-search-bar-float-input] input').value = '';

  // hide no results div
  $('[data-au-glossary-no-results]').classList.add('au-hide');

  // reset previous strong
  glossaryMain.querySelectorAll('[data-au-glossary-strong]').forEach((el) => {
    const parent = el.parentNode;
    parent.replaceChild(document.createTextNode(el.textContent), el);
  });
}

function searchBarGlossary() {
  $$('[data-au-search-items] [data-au-search-bar-button]').forEach((searcher) => {
    searcher.addEventListener('click', function () {
      const input = searcher.parentNode.querySelector('[data-au-search-bar-float-input] input');
      const value = input.value;

      if (value) {
        auGlossarySearch(value);
      }
    });
  });

  $('[data-au-search-items] [data-au-float-input-clear]').addEventListener('click', function () {
    auGlossarySearchClear();
  });

  $('[data-au-glossary-no-results]').addEventListener('click', function () {
    auGlossarySearchClear();
  });
}

export default { init };
